import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type ModalSize, type CreateTicketEvent } from '@/common/types/event'
import { type NavAction, type NavItem, type CreateCasePayload, NavItemContext, NavItemTypeEnum } from '@/common/types/navigation'
import { type IModuleContext } from '@/common/types/module'
import i18n from '@/plugins/i18n'

const { t } = i18n.global

interface Options {
  size?: ModalSize
  customer?: boolean
  timeCounterVisible?: boolean
  ticketId?: string
}

export class CreateCaseNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(context: IModuleContext, action: NavAction<any>) {
    super(context, action)
    this.textKey = 'assist.action.case'
  }

  buildCreateCaseEvent(screenId: string, text: string, { size = 'large', customer = false, timeCounterVisible = false, ticketId }: Options = {}) {
    let event: CreateTicketEvent = {
      screenId,
      screenName: text,
      timeCounterVisible,
      customer,
      modalSize: size,
    }

    if (ticketId) {
      event = { ...event, ticketId }
    }

    return event
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    const payload: CreateCasePayload = action.actionData

    let target: string = ''
    let type: NavItemTypeEnum = NavItemTypeEnum.Link
    let event: CreateTicketEvent | undefined

    if (payload !== undefined) {
      switch (payload.channel) {
        case 'default':
          if (payload.screenId) {
            target = 'front:create-ticket'
            type = NavItemTypeEnum.LegacyModal
            event = this.buildCreateCaseEvent(payload.screenId, this.getText(action, itemContext), {
              ...this.context.getToken(),
              ...action.actionData,
            })
          } else if (payload.skillGroupId) {
            target = `/assist/ticket/create/oneclick/${payload.skillGroupId}${this.context.getUrlParams()}`
          }
          break
        case 'sms':
          if (payload.skillGroupId) {
            target = `/assist/sms/create/${payload.skillGroupId}`
          }
          break
      }
    }

    yield {
      category: 'create-case',
      text: this.getText(action, itemContext),
      target,
      type,
      payload: event,
    } as NavItem
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getText(action: NavAction<any>, itemContext: NavItemContext) {
    return NavItemContext.Single === itemContext ? t(this.textKey) : super.getText(action, itemContext)
  }
}
